import React from 'react';
import moment from 'moment'; 

import {
	Col,
	Icon
} from '@sketchpixy/rubix';

export class PlanningDateIntervalSelector extends React.Component {

    constructor(props) {
        super(props);

    }

	addDay() {
		this.props.onChange({
			startDate: moment(this.props.startDate).add(1, 'day').toDate(),
			endDate: moment(this.props.endDate).add(1, 'day').toDate(),
		});
	}

	subDay() {
		this.props.onChange({
			startDate: moment(this.props.startDate).subtract(1, 'day').toDate(),
			endDate: moment(this.props.endDate).subtract(1, 'day').toDate(),
		});
	}

	render() {
		return (
			<div>
				<Col sm={2}>
					<Icon bundle='glyphicon' glyph="arrow-left" onClick={::this.subDay} />
				</Col>
				<Col sm={8}>
					<p>
						Du 
						&nbsp;
						{ moment(this.props.startDate).format('DD/MM/YYYY') }
						&nbsp;
						au 
						&nbsp;
						{ moment(this.props.endDate).format('DD/MM/YYYY') }
					</p>
				</Col>
				<Col sm={2}>
					<Icon bundle='glyphicon' glyph="arrow-right" onClick={::this.addDay} />
				</Col>
			</div>
		);
	}
}

PlanningDateIntervalSelector.propTypes = {
	startDate: React.PropTypes.instanceOf(Date),
	endDate: React.PropTypes.instanceOf(Date),
	onChange: React.PropTypes.func
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/flights/PlanningDateIntervalSelector.js
 **/